"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CookieBar = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = require("../button/Button");
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  INFO: 'info'
};
const CookieBar = _ref => {
  let {
    className,
    text,
    href,
    linkName,
    buttonText,
    color,
    onClick
  } = _ref;
  const classes = (0, _styles.useStyles)();
  const computedVariantClass = () => {
    switch (color) {
      case VARIANTS.PRIMARY:
        return classes.primaryVariant;
      case VARIANTS.SECONDARY:
        return classes.secondaryVariant;
      default:
        return classes.infoVariant;
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)([className, classes.wrapper, computedVariantClass()])
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.text
  }, text, /*#__PURE__*/_react.default.createElement("a", {
    href: href,
    target: "blank"
  }, linkName), "."), color === 'info' ? /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    className: classes.infoButton,
    onClick: onClick
  }, buttonText) : /*#__PURE__*/_react.default.createElement(_Button.Button, {
    color: color,
    variant: "contained",
    onClick: onClick
  }, buttonText));
};
exports.CookieBar = CookieBar;
CookieBar.propTypes = {
  /**
   * Classe de estilo da barra de cookie
   */
  className: _propTypes.default.string,
  /**
   * Texto a ser exibido na barra
   */
  text: _propTypes.default.string,
  /**
   * Link para onde o usuário deve ser redirecionado
   */
  href: _propTypes.default.string,
  /**
   * Texto do link a ser clicado
   */
  linkName: _propTypes.default.string,
  /**
   * Texto do botao
   */
  buttonText: _propTypes.default.string,
  /**
   * Cor do botão
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'info']),
  /**
   * Funçao a ser realizada ao clicar no botao
   */
  onClick: _propTypes.default.func.isRequired
};
CookieBar.defaultProps = {
  className: 'lgpd',
  text: 'Esse site utiliza cookies para oferecer uma melhor experiência de navegação, analisar como você interage em nosso site, otimizar o desempenho e personalizar o conteúdo. Ao utilizar este site, você concorda com o uso de cookies. Saiba mais em nosso ',
  href: 'https://minhabiblioteca.com.br/politica-de-privacidade/',
  linkName: 'Portal de Privacidade',
  buttonText: 'OK',
  color: 'primary'
};
var _default = exports.default = CookieBar;